var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdoptiumLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345.04 76.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 63.54,
    y1: 65.12,
    x2: 15.36,
    y2: 39.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e1948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c1537"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 32.94,
    y1: 7.96,
    x2: 59.47,
    y2: 67.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a81255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e1948"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 13.24,
    y1: 68.48,
    x2: 39.19,
    y2: 8.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e72867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a81255"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.05 45.11a2.35 2.35 0 01-.87 1.84 3 3 0 01-2 .76 2.57 2.57 0 01-1.38-.39 2.67 2.67 0 01-1-1.19l-1.48-3.33h-10.67l-1.51 3.33a2.65 2.65 0 01-1 1.19 2.62 2.62 0 01-1.4.39 3 3 0 01-2-.76 2.3 2.3 0 01-.91-1.84 2.81 2.81 0 01.3-1.22L103.8 26a3 3 0 011.26-1.36 3.68 3.68 0 011.86-.48 3.73 3.73 0 011.85.48 3 3 0 011.28 1.36l8.7 17.86a2.81 2.81 0 01.3 1.25zm-15.35-6.85h6.59L107 30.91zm28.48 8.63a2.81 2.81 0 01-.73-2.08V27.19a2.53 2.53 0 012.8-2.8h6.66a14.55 14.55 0 016.64 1.4 9.87 9.87 0 014.26 4 12.28 12.28 0 011.48 6.21 12.58 12.58 0 01-1.46 6.25 9.74 9.74 0 01-4.25 4 14.89 14.89 0 01-6.67 1.38h-6.66a2.8 2.8 0 01-2.07-.74zm13.39-5.82a6.84 6.84 0 001.7-5.09 6.79 6.79 0 00-1.7-5.07 7 7 0 00-5.09-1.65h-3v13.48h3a7 7 0 005.09-1.67zm25.17 5.37a10 10 0 01-4-4.15 13.38 13.38 0 01-1.45-6.29 13.41 13.41 0 011.41-6.31 9.93 9.93 0 014-4.13 13.87 13.87 0 0112.35 0 9.77 9.77 0 014 4.13 13.41 13.41 0 011.4 6.31 13.38 13.38 0 01-1.41 6.31 10 10 0 01-4 4.15 13.64 13.64 0 01-12.32 0zm10.29-5a8.54 8.54 0 001.49-5.44 8.39 8.39 0 00-1.5-5.4 5.51 5.51 0 00-8.22 0 8.46 8.46 0 00-1.48 5.4 8.52 8.52 0 001.48 5.44 5.5 5.5 0 008.23 0zM202.81 47a3 3 0 01-.81-2.19V27.19a2.53 2.53 0 012.8-2.8h8.43a8.55 8.55 0 016 2 7 7 0 012.14 5.45 7 7 0 01-2.16 5.43 8.5 8.5 0 01-6 2h-5.17v5.6a2.93 2.93 0 01-.82 2.19 3.06 3.06 0 01-2.24.81 3 3 0 01-2.17-.87zm12.09-13a2.65 2.65 0 00.81-2.14q0-2.86-3.3-2.87h-4.35v5.7h4.35a3.78 3.78 0 002.49-.69zm25.95 13a2.87 2.87 0 01-.85-2.16V29.29h-4.64a3.22 3.22 0 01-2.16-.61 2.31 2.31 0 01-.71-1.86 2.27 2.27 0 01.71-1.82 3.28 3.28 0 012.16-.59h15.42a3.31 3.31 0 012.16.59 2.26 2.26 0 01.7 1.84 2.31 2.31 0 01-.7 1.86 3.26 3.26 0 01-2.16.61h-4.65v15.5a2.86 2.86 0 01-.84 2.16 3.45 3.45 0 01-4.44 0zm26.38 0a3 3 0 01-.8-2.19V27.19a2.78 2.78 0 013-3 3 3 0 012.24.81 2.89 2.89 0 01.83 2.16v17.65a2.93 2.93 0 01-.83 2.19 3 3 0 01-2.24.81 3 3 0 01-2.2-.81zm22.14-1.66c-1.74-1.71-2.62-4.22-2.62-7.51V27.19a3.06 3.06 0 015.13-2.19 3 3 0 01.8 2.16v10.9a5.91 5.91 0 001.12 3.85 4.54 4.54 0 006.46 0 5.85 5.85 0 001.12-3.85V27.19a2.79 2.79 0 013-3 3 3 0 012.17.81 2.89 2.89 0 01.82 2.16v10.67q0 4.91-2.65 7.49T297 47.91q-5 0-7.63-2.57zM344.25 25a3 3 0 01.79 2.15v17.96a2.67 2.67 0 01-.72 2 2.85 2.85 0 01-3.81 0 2.64 2.64 0 01-.74-2v-9.69L336 42.34a4.35 4.35 0 01-1.18 1.5 2.5 2.5 0 01-1.49.44 2.47 2.47 0 01-1.48-.44 4.24 4.24 0 01-1.18-1.5L327 35.62v9.49a2.64 2.64 0 01-.74 2 2.61 2.61 0 01-1.93.74 2.57 2.57 0 01-1.89-.73 2.64 2.64 0 01-.74-2V27.19a2.94 2.94 0 01.81-2.15 2.76 2.76 0 012.05-.82 2.74 2.74 0 011.62.51 4 4 0 011.22 1.47l6.06 11.4 6-11.4a3.08 3.08 0 012.77-2 2.74 2.74 0 012.02.8zM36.34 0a16.62 16.62 0 00-14.86 9.1l-.07.13-.06.13-19.79 42.9-.15.32-.11.33a22.11 22.11 0 00-1.3 6.4 16.7 16.7 0 0031.68 7.37l17.19 7.73A16.5 16.5 0 0056 76a16.72 16.72 0 0016.7-16.7 21.78 21.78 0 00-1.3-6.4l-.11-.33-.14-.32C52 10.81 51.21 9.09 51.05 8.78A16.71 16.71 0 0036.34 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.09 63.16L36.35 39.85l-8.12 17.6 23.58 10.61a9.75 9.75 0 01-4.72-4.9z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.77 55.2L45.32 13l-.18-.38-.14-.33-.11-.19a9.66 9.66 0 01.28 8.62l-8.82 19.13 10.74 23.31a9.7 9.7 0 0018.6-3.85 9.59 9.59 0 00-.92-4.11z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.34 7a9.67 9.67 0 00-8.63 5.29l-.14.32c-.06.12-.13.25-.18.38L7.92 55.2a9.7 9.7 0 1017.68 8l19.57-42.48A9.69 9.69 0 0036.34 7z",
    fill: "url(#c)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdoptiumLogo);
export default __webpack_public_path__ + "static/media/AdoptiumLogo.a01857306dc397074fb27393dc8f145a.svg";
export { ForwardRef as ReactComponent };